// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__n7AVo","content":"LayoutSettings_content__3NvYc"};